import { Fragment } from "react";
import InnerHTML from "dangerously-set-html-content";
import { t } from "@/i18n-js/instance";
import { FormItem } from "@/react/components/SettingsApp/General/FormItem";
import { Form } from "@circle-react-uikit/Form";
import { I18N_ROOT } from "../";

export const IosAppEnabledField = () => (
  <>
    <div className="border-primary border-t" />
    <FormItem
      name="community_setting.ios_app_enabled"
      translationRoot={I18N_ROOT}
      childrenWrapper={Fragment}
      isHorizontal
      description={
        <InnerHTML
          html={t([I18N_ROOT, "community_setting.ios_app_enabled_description"])}
        />
      }
    >
      <Form.ToggleSwitch
        name="community_setting.ios_app_enabled"
        variant="small"
      />
    </FormItem>
  </>
);
